import { useTranslation } from "react-i18next";
import { DigitCodeInput } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";

interface CardContentSignInMfaProps {
  email: string;
  onClickMfaSignin?: (code: string) => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentSignInMfa = ({
  email,
  onClickMfaSignin = () => {},
  ...props
}: CardContentSignInMfaProps) => {
  const { t } = useTranslation();

  return (
    <CPCard>
      <DigitCodeInput
        title={t('digit_code.title')}
        hint={t('digit_code.hint', { email })}
        labelButton={t('buttons.next')}
        onClick={onClickMfaSignin}
        errorMessage={props.errorMessage}
        loading={props.loading}
      />

    </CPCard>
  );
};
